<template>
  <div class="wrapper">
    <div class="header">
      <div
        style="flex: 1;"
        v-if="queryFilter.y === 'category'"
        :gl-tooltip="
          !$store.state.isQueryFullFeatured
            ? msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE
            : ''
        "
        gl-tooltip-direction="left"
        class="button-group button-group__layout"
      >
        <md-button
          v-for="level in itemCategoryLevels"
          class="md-raised button-group__button"
          :value="level.level"
          :key="level.level"
          :disabled="!$store.state.isQueryFullFeatured"
          @click="drilldown(level.level)"
          >{{ level.name }}へ
        </md-button>
      </div>
      <div style="flex: 1;" v-else>
        <!-- padding -->
      </div>
      <div
        :gl-tooltip="queryId ? 'Excel出力' : ''"
        gl-tooltip-direction="down"
        @click="downloadExcel"
      >
        <gl-button icon-button>
          <md-icon> <font-awesome-icon icon="file-excel"/></md-icon>
        </gl-button>
      </div>
    </div>
    <div class="table-wrapper" ref="tableContainer">
      <gl-table ref="myTable" v-bind="resultTable" />
    </div>

    <!-- 顧客コレクション -->
    <customer-collection
      :customers="customers"
      @update:customers="customers = $event"
      @download="downloadCustomers"
      :downloading="downloadingCustomerFile"
    >
      <query-transitions :query-id="queryId" disabled />
    </customer-collection>

    <md-dialog
      class="querying-dialog"
      :md-active.sync="querying"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content>
        <div class="spinner-container">
          <img src="@/assets/images/Web_hosting.svg" />
          <spinner />
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-snackbar
      md-position="center"
      :md-duration="4000"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>対象の分類を一覧から選択してください</span>
    </md-snackbar>
  </div>
</template>

<script>
import { mergeWith, isArray } from 'lodash'

import CustomerCollection from '@/components/CustomerCollection.vue'
import GlTable from '@/components/GlTable.vue'
import Spinner from '@/components/Spinner.vue'
import QueryTransitions from '@/components/QueryTransitions.vue'

import { initializeRestrictedQueryFilter } from '@/queryfilter/util'
import { SET_IS_QUERY_FULL_FEATURED } from '@/const/mutation-types'

// 分析条件モデル
import category from '@/queryfilter/category'
import term from '@/queryfilter/term'
import store from '@/queryfilter/store'
import customer from '@/queryfilter/customer'

import repository from '@/repositories/Repository'
import msg from '@/const/messages'

let hold = false

export default {
  components: { CustomerCollection, GlTable, Spinner, QueryTransitions },
  data() {
    return {
      msg,
      resourceName: 'roots/detail',
      queryId: undefined,
      itemCategoryLevels: [],
      queryFilter: {
        category: {
          order: 2,
          summaryKey: 'categoryRoots',
          ...category.get(),
        },
        customer: {
          order: 4,
          ...customer.get(),
        },
        term: {
          order: 1,
          summaryKey: 'termPos',
          base: {
            ...term.get(),
          },
          compare: {
            ...term.get(),
          },
        },
        store: {
          order: 3,
          summaryKey: 'storeCompare',
          base: {
            ...store.get(),
          },
          compare: {
            ...store.get(),
          },
        },
        ranks1: [],
        ranks2: [],
        // 強み or 弱み
        sw: undefined,
        // 子指標
        evaluation: undefined,
        // 縦軸（category or store）
        y: undefined,
        findRootsBy: undefined,
        referenceId: undefined,
        drilldown: {
          queryId: undefined,
        },
      },
      customers: [],
      querying: false,
      downloadingCustomerFile: false,
      showSnackbar: false,
      resultTable: {
        columns: [],
        groupHeaders: [],
        rows: [],
        width: 0,
        height: 0,
        selectable: true,
        customFormatter: {
          sw: (_, cell, value) => {
            if (value && value.startsWith('強み')) {
              cell.style.color = 'rgb(33, 150, 243)'
            } else if (value && value.startsWith('弱み')) {
              cell.style.color = 'rgb(244, 67, 54)'
            }
          },
          char: (_, cell, value) => {
            if (value && value.endsWith('多い')) {
              cell.style.color = 'rgb(33, 150, 243)'
            } else if (value && value.endsWith('少ない')) {
              cell.style.color = 'rgb(244, 67, 54)'
            }
          },
          '1_2_dev': (row, cell, value) => {
            if (!row.category_code && !row.store_code) {
              return
            }
            if (value === undefined) {
              return
            }

            if (value >= 40) {
              cell.style.backgroundColor = 'rgb(187, 222, 251)'
            } else if (value < 40) {
              cell.style.backgroundColor = 'rgb(255, 205, 210)'
            }
          },
          '1_1_dev': (row, cell, value) => {
            if (!row.category_code && !row.store_code) {
              return
            }
            if (value === undefined) {
              return
            }

            if (value >= 50) {
              cell.style.backgroundColor = 'rgb(187, 222, 251)'
            } else if (value < 50) {
              cell.style.backgroundColor = 'rgb(255, 205, 210)'
            }
          },
          linkify: (rowData, cell, value, colName) => {
            if (value === 0) {
              return
            }

            cell.classList.add('customer-collection-cell')
            cell.setAttribute(
              'data-customer-collection',
              rowData.customer_filter[colName],
            )
            const toggle = e => {
              if (!this.resultTable.columns) {
                throw new Error('Column not found')
              }
              // hit the column
              const col = this.resultTable.columns.find(
                c => c.colName === colName,
              )
              const id = e.target.getAttribute('data-customer-collection')
              let text
              let name = rowData.category_name // TODO 店舗コードも
              if (col.colName === 'customer_count1_1') {
                text = `${name}（自店・当期間）`
              } else if (col.colName === 'customer_count1_2') {
                text = `${name}（自店・前期間）`
              } else if (col.colName === 'customer_count2_1') {
                text = `${name}（比較店・当期間）`
              } else if (col.colName === 'customer_count2_2') {
                text = `${name}（比較店・前期間）`
              }

              // if (colName === 'customer_count') {
              //   text = trimAll(rowData.store_name)
              // } else {
              //   text = `${trimAll(rowData.store_name)} - ${col.headerText}`
              // }

              const customer = { id, text }
              this.toggleCustomerCollection(customer)

              e.stopPropagation()
            }

            cell.addEventListener('mousedown', e => {
              hold = true
              document.body.classList.add('no-select')
              toggle(e)
            })
            cell.addEventListener('mouseup', () => {
              hold = false
              document.body.classList.remove('no-select')
            })

            cell.addEventListener('mouseenter', e => {
              // console.log('hold', hold)
              if (!hold) {
                return
              }
              toggle(e)
            })
          },
        },
      },
    }
  },
  watch: {
    //
    // queryIdの変化で実施することは以下の3つ
    //
    // 1. 分析IDが提供されている
    //
    //    この画面で結果を表示したい分析IDです。分析ステータスは分析中、若しくは完了
    //    （異常終了含む）両方を考慮に入れる必要があります。
    //
    // 2. 参照分析IDが提供されている
    //
    //    画面遷移により開かれた画面です。参照分析IDで指定された分析IDの分析条件
    //    を使い（一部変更）このResourceで分析します。分析が完了したら分析IDをURLに
    //    セットし、1に飛ばします（結果の表示は1のルートに任せます）。
    //
    // 3. 分析IDも参照分析IDもない
    //
    //    この画面が単体で分析することはないので、このケースは存在しません。
    //
    '$route.params.queryId': {
      // 画面表示時にもキャッチできるようにimmediateとしています
      immediate: true,
      async handler(queryId) {
        const referenceId = this.$route.query.reference

        if (queryId) {
          // 1. 分析IDが提供されている
          this.queryId = queryId

          this.querying = true

          // QueryFilterへの反映が完了し、各条件コンポーネントのエラー判定が
          // 行われることを保証するため、applyQueryFilterによるDOM変更完了を待ちます。
          await this.$nextTick()

          this.$emit('update:activeTab', 'result')

          // 分析は既に完了している場合もありますが、その場合は完了通知を監視に接続した
          // 直後に分析完了通知が飛びます。分析のステータスは気にせず完了待機に入ります。
          this.$queryNotification.connect(queryId)
        } else if (referenceId) {
          // 2. 参照分析IDが提供されている
          const queryFilter = await this.$longQuery.fetchQueryFilter(
            referenceId,
          )

          const ranks1 = this.$route.query.ranks1
          const ranks2 = this.$route.query.ranks2
          const y = this.$route.query.y
          const evaluation = this.$route.query.evaluation

          queryFilter.ranks1 = isArray(ranks1) ? ranks1 : [ranks1]
          queryFilter.ranks2 = isArray(ranks2) ? ranks2 : [ranks2]
          queryFilter.y = y
          queryFilter.evaluation = evaluation
          queryFilter.referenceId = referenceId

          const override = JSON.parse(this.$route.query.override)

          const mergedQueryFilter = mergeWith(queryFilter, override, (o, s) => {
            return isArray(s) ? s : undefined
          })

          this.applyQueryFilter(mergedQueryFilter)

          // この画面にはユーザー自身の分析ボタンアクションはなく、Rootsからの遷移かドリルダウンしかありません。
          this.executeQuery()
        } else {
          // 3. 分析IDも参照分析IDもない

          // この画面は自身の分析機能がないのでリファレンスまたは表示する分析IDが必須
          throw new Error('分析IDがありません')
        }
      },
    },
  },
  methods: {
    /**
     * クエリの進捗通知（完了）受信時処理
     */
    async loadQueryResult({ id: queryId, status }) {
      if (this.queryId !== queryId) {
        return
      }

      this.querying = false

      if (status === 'Error') {
        throw new Error('分析時にエラーが発生しました。')
      }

      const queryFilter = await this.$longQuery.fetchQueryFilter(queryId)
      if (!queryFilter) {
        throw new Error('分析IDが見つかりませんでした。', queryId)
      }
      this.applyQueryFilter(queryFilter)

      await this.loadItemCategoryLevelsData()

      const queryInfo = await this.$longQuery.fetchQueryInfo(
        this.resourceName,
        queryId,
      )

      const isQueryFullFeatured =
        queryInfo.queryFullFeatured !== undefined &&
        queryInfo.queryFullFeatured !== undefined
          ? queryInfo.queryFullFeatured
          : true
      this.$store.commit(SET_IS_QUERY_FULL_FEATURED, isQueryFullFeatured)
      // 制限モードの場合、分析条件で復元不可のものが無いかチェック
      if (!queryInfo.queryFullFeatured) {
        initializeRestrictedQueryFilter(this.queryFilter)
      }

      this.resultTable.columns = queryInfo.grid.colModel
      this.resultTable.groupHeaders = queryInfo.grid.groupHeader

      const url = await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        queryId,
      )

      const queryParameters = {
        sw: this.queryFilter.sw,
        evaluation: this.queryFilter.evaluation,
        findRootsBy: this.queryFilter.findRootsBy,
        y: this.queryFilter.y,
        itemCategoryLevel: this.queryFilter.category.itemCategoryLevel,
      }

      const queryParameter = Object.entries(queryParameters)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')

      const result = await repository.giggle.get(`${url}?${queryParameter}`)
      const rows = result.data

      this.resultTable.rows = rows
    },
    async executeQuery() {
      this.querying = true

      const queryInfo = await this.$longQuery.executeQuery(
        this.resourceName,
        this.mapQueryFilterForApi(this.queryFilter),
      )

      await this.$longQuery.saveQueryFilter(queryInfo.id, this.queryFilter)

      // 結果表示用URLに遷移するが、実態はこの画面
      const nextPage = `/query-roots-detail/${queryInfo.id}`
      if (this.$route.query.reference) {
        this.$router.replace(nextPage)
      } else {
        this.$router.push(nextPage)
      }
    },
    async drilldown(itemCategoryLevel) {
      const selectedRows = this.$refs.myTable.getSelectedRowData()
      const fromItemCategoryLevel = this.queryFilter.category.itemCategoryLevel
      const toItemCategoryLevel = itemCategoryLevel
      const allChecked = this.$refs.myTable.isSelectAllChecked()

      if (selectedRows.length === 0 && !allChecked) {
        this.showSnackbar = true
        return
      }
      let categories = selectedRows.map(r => r.category_code)

      // 全選択チェックボックス入っている場合はselectedRows関係なく全行取得してドリルダウンを行う。
      if (allChecked) {
        categories = this.resultTable.rows.map(r => r.category_code)
      }

      this.showSnackbar = false
      this.queryFilter.drilldown.queryId = this.queryId
      this.queryFilter.category.itemCategoryLevel = itemCategoryLevel
      this.queryFilter.category.categories = await this.getTargetDrilldownCategories(
        this.queryFilter.category.company,
        fromItemCategoryLevel,
        toItemCategoryLevel,
        categories,
      )

      this.executeQuery()
    },
    applyQueryFilter(queryFilter) {
      category.applyPayload(this.queryFilter.category, queryFilter.category)
      term.applyPayload(this.queryFilter.term.base, queryFilter.term.base)
      term.applyPayload(this.queryFilter.term.compare, queryFilter.term.compare)
      store.applyPayload(this.queryFilter.store.base, queryFilter.store.base)
      store.applyPayload(
        this.queryFilter.store.compare,
        queryFilter.store.compare,
      )
      customer.applyPayload(this.queryFilter.customer, queryFilter.customer)
      this.queryFilter.sw = queryFilter.sw
      this.queryFilter.ranks1 = queryFilter.ranks1
      this.queryFilter.ranks2 = queryFilter.ranks2
      this.queryFilter.evaluation = queryFilter.evaluation
      this.queryFilter.y = queryFilter.y
      this.queryFilter.findRootsBy = queryFilter.findRootsBy
      this.queryFilter.referenceId = queryFilter.referenceId
      if (queryFilter.drilldown) {
        this.queryFilter.drilldown.queryId = queryFilter.drilldown.queryId
      }
    },
    mapQueryFilterForApi(queryFilter) {
      return {
        category: category.mapToApiPayload(queryFilter.category),
        customer: customer.mapToApiPayload(queryFilter.customer),
        term: {
          base: term.mapToApiPayload(queryFilter.term.base),
          compare: term.mapToApiPayload(queryFilter.term.compare),
        },
        store: {
          base: store.mapToApiPayload(queryFilter.store.base),
          compare: store.mapToApiPayload(queryFilter.store.compare),
        },
        ranks1: queryFilter.ranks1,
        ranks2: queryFilter.ranks2,
        y: queryFilter.y,
        evaluation: queryFilter.evaluation,
        findRootsBy: queryFilter.findRootsBy,
        referenceId: queryFilter.referenceId,
        drilldown: {
          ...queryFilter.drilldown,
        },
      }
    },
    loadItemCategoryLevelsData() {
      const itemCategoryLevels = this.$store.state.itemCategoryLevels[
        this.queryFilter.category.company
      ]

      //条件で選択している階層までは削除
      const deleteIndex = itemCategoryLevels.findIndex(
        i => i.level == this.queryFilter.category.itemCategoryLevel,
      )
      this.itemCategoryLevels = itemCategoryLevels.slice(deleteIndex + 1)

      if (
        this.queryFilter.y === 'store' ||
        this.itemCategoryLevels.length === 0
      ) {
        this.resultTable.selectable = false
      } else {
        this.resultTable.selectable = true
      }
    },
    /**
     * fromのcategoriesよりtoのカテゴリを取得
     */
    async getTargetDrilldownCategories(company, from, to, categories) {
      const chunkSize = 100
      const targetDrilldownCategories = []
      for (let i = 0; i < categories.length; i += chunkSize) {
        const chunkCategories = categories.slice(i, i + chunkSize)
        const chunkDrilldownCategories = await this.$repositories
          .get('itemCategory')
          .getDrilldownData(company, from, to, chunkCategories)
        targetDrilldownCategories.push(...chunkDrilldownCategories)
      }
      return targetDrilldownCategories.map(c => c.code)
    },
    /**
     * 顧客コレクションへの登録
     */
    addCustomerCollection(customer) {
      const cell = document.querySelector(
        `[data-customer-collection="${customer.id}"]`,
      )
      if (!cell) {
        throw new Error(`ID="${customer.id}"セルが見つかりませんでした`)
      }
      cell.classList.toggle('customer-collection-selected')

      this.customers = [customer, ...this.customers]
    },
    /**
     * 顧客コレクションからの削除
     */
    removeCustomerCollection(customer) {
      const cell = document.querySelector(
        `[data-customer-collection="${customer.id}"]`,
      )
      if (!cell) {
        throw new Error(`ID="${customer.id}"セルが見つかりませんでした`)
      }
      cell.classList.toggle('customer-collection-selected')

      this.customers = this.customers.filter(c => c.id !== customer.id)
    },
    /**
     * 顧客コレクションの存在すれば削除、存在しなければ追加
     */
    toggleCustomerCollection(customer) {
      if (this.customers.find(c => c.id === customer.id)) {
        this.removeCustomerCollection(customer)
      } else {
        this.addCustomerCollection(customer)
      }
    },
    async downloadCustomers(customers) {
      if (!this.queryId) {
        // 分析結果画面に配置している顧客コレクションからのイベントなので、
        // 分析IDは必ずあるはずなので通常ここは通らない。
        throw new Error('分析IDがありません')
      }
      if (!customers || customers.length === 0) {
        // 顧客が選択されていない状態では顧客コレクションは開いていないので、
        // 通常ここは通らない。
        throw new Error('顧客が選択されていません')
      }

      this.downloadingCustomerFile = true

      try {
        const customerGroup = await this.$customerGroup.create(
          this.queryId,
          customers.map(c => c.id),
        )
        const url = await this.$customerGroup.archive(
          customerGroup.customerGroupId,
        )

        window.open(url)
      } catch (e) {
        this.downloadingCustomerFile = false
        throw e
      }

      this.downloadingCustomerFile = false
    },
    /**
     * Excelファイルをダウンロードする
     */
    async downloadExcel() {
      const queryParameters = {
        sw: this.queryFilter.sw,
        evaluation: this.queryFilter.evaluation,
        findRootsBy: this.queryFilter.findRootsBy,
        y: this.queryFilter.y,
        itemCategoryLevel: this.queryFilter.category.itemCategoryLevel,
      }

      const url = await this.$longQuery.getExcelUrl(
        this.resourceName,
        this.queryId,
        queryParameters,
      )

      window.open(url)
    },
    updateTableSize() {
      const container = this.$refs.tableContainer
      if (container) {
        this.resultTable.width = container.clientWidth
        this.resultTable.height = container.clientHeight
      }
    },
  },
  async created() {
    const queryNotificationSubscription = this.$queryNotification.observable.subscribe(
      this.loadQueryResult,
    )
    this.$on('hook:beforeDestroy', () =>
      queryNotificationSubscription.unsubscribe(),
    )
  },
  mounted() {
    this.updateTableSize()

    const subscription = this.$windowResize.subscribe(this.updateTableSize)
    this.$on('hook:beforeDestroy', () => {
      if (subscription) {
        subscription.unsubscribe()
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  overflow: hidden;
  padding: var(--spacing-large);
}

.header {
  display: flex;
}

.table-wrapper {
  flex: 1;
}

.spinner-container {
  position: relative;
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: center;
  width: 100%;

  img {
    position: absolute;
    width: 200px;
    opacity: 0.4;
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    &:hover {
      opacity: 0.8;
      transform: scale(1.1);
    }
  }
}
</style>
